import { Switch as MuiSwitch } from '@mui/material'

const Switch = ({ checked, isInactive, ...rest }) => {
  return (
    <MuiSwitch
      slotProps={{
        root: {
          sx: {
            filter: isInactive && 'grayscale(100%)',
          }
        },
        track: {
          sx: {
            backgroundColor: checked ? '' : 'grey',
          }
        }
      }}
      checked={checked}
      {...rest}
    />
  )
}

export { Switch }
